import { wrapReducer } from "@client/content/lib/helper";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type UnsubscribeBeginActionData } from "./actions";
import { type Unsubscribe } from "./types";

const reducer = (state: Unsubscribe.AppState = defaultState, action: ReduxAction<any>): Unsubscribe.AppState => {
  switch (action.type) {
    case Actions.UnsubscribeBegin: {
      const { isInstant } = action.params as UnsubscribeBeginActionData;
      return {
        ...state,
        status: isInstant ? "UnsubscribingInstant" : "Unsubscribing"
      };
    }
    case Actions.UnsubscribeFailure: {
      return {
        ...state,
        status: Status.Ready
      };
    }
    case Actions.UnsubscribeSuccess: {
      return {
        ...state,
        status: Status.Ready,
        step: 2
      };
    }
    default:
      return state;
  }
};

export const defaultState: Unsubscribe.AppState = {
  id: "",
  status: Status.Ready,
  step: 1
};
export const previewState = defaultState;
export default wrapReducer({ defaultState, reducer, previewState });
